import React, { useCallback } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';

export type HoverDetectionContainerOwnProps = {
    children: React.ReactNode;
    onHoverChange: (isHovered: boolean) => void;
    style?: StyleProp<ViewStyle>;
};

export type HoverDetectionContainerProps = HoverDetectionContainerOwnProps;

const HoverDetectionContainer: React.FC<HoverDetectionContainerProps> = ({ children, onHoverChange, style }) => {
    const onEnter = useCallback(() => {
        onHoverChange(true);
    }, [onHoverChange]);

    const onLeave = useCallback(() => {
        onHoverChange(false);
    }, [onHoverChange]);

    return (
        <View onPointerEnter={onEnter} onPointerLeave={onLeave} style={style} onPointerCancel={onLeave}>
            {children}
        </View>
    );
};

export default React.memo(HoverDetectionContainer);
